






























import { Component } from 'nuxt-property-decorator'
import TourBusinessBase from '~/components/tour/tour-base/business-base'

@Component
export default class TourAdSectionDesktop extends TourBusinessBase {
  static displayName = 'DesktopExperienceTour_advertising'

  get imgList() {
    return this.businessData?.list || []
  }

  get carouselProps() {
    const flag = this.imgList?.length > 1

    return {
      loop: flag,
      autoplay: flag,
      controllerPosition: 'inside'
    }
  }

  genHref(path: string) {
    if (process.client) {
      const origin = window.location.origin
      return origin + path
    }

    return path
  }

  getSpm(deeplink: string, index: number) {
    const ext = {
      LinkURL: this.genHref(deeplink),
      Order: index
    }

    return `CampaignBanner_LIST?idx=${index}&len=${this.imgList.length}&ext=${encodeURIComponent((JSON.stringify(ext)))}`
  }
}
